const TestimonialTemplate = ({ testimonial, headshot, name, title }) => {
    return (
        <div className="w-full flex flex-col px-[80px] md:px-[80px] lg:px-[120px] 1.5xl:px-[300px] 3xl:px-[450px]">
            <p className="mb-0 font-proximanova text-[18px]  text-[#505050] font-proximanova font-[400] text-start">{testimonial}</p>

            <div className="mt-[40px] 3xl:mt-[60px] flex flex-col sm:flex-row sm:mx-auto items-center 1.5xl:gap-[30px]">
                <div className="w-[120px] h-[120px] 1.5xl:min-w-[160px] 1.5xl:max-w-[160px]  1.5xl:min-h-[160px] 1.5xl:max-h-[160px] bg-cover bg-center" style={{ backgroundImage: `url(${headshot})` }}></div>

                <div className="mt-[20px] flex flex-col">
                    <h5 className="w-full sm:text-start font-proximanova text-testimonialPerson md:text-[30px] 1.5xl:text-[26px] font-[700]">{name} </h5>
                    <p className="w-full sm:text-start font-proximanova text-testimonialPerson text-[18px]  text-[#505050] font-[400]">{title}</p>
                </div>
            </div>
        </div>
    );
}

export default TestimonialTemplate;